import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.FlexiInterestOnlyCard.title',
        defaultMessage:
            'Repay interest only for <button>{ioPeriod}</button> months followed by 12 monthly instalments'
    },
    alert: {
        id: '_.xsell.FlexiInterestOnlyCard.alert',
        defaultMessage:
            '<bold>Best for protecting cash flow:</bold> Only pay interest for the first 3 months'
    },
    interest: {
        id: '_.xsell.FlexiInterestOnlyCard.interest',
        defaultMessage: 'Interest'
    },
    interestAmount: {
        id: '_.xsell.FlexiInterestOnlyCard.interest_amount',
        defaultMessage: '<fetching>{interest}%</fetching> per 30 days, no fees'
    },
    repayments: {
        id: '_.xsell.FlexiInterestOnlyCard.repayments',
        defaultMessage: 'Repayments'
    },
    repaymentAmount: {
        id: '_.xsell.FlexiInterestOnlyCard.repayment_amount',
        defaultMessage:
            'interest-only for 3 months, then <fetching>{amount}</fetching>/mo'
    },
    viewSchedule: {
        id: '_.xsell.FlexiInterestOnlyCard.view_schedule',
        defaultMessage: 'View Schedule'
    },
    total: {
        id: '_.xsell.FlexiInterestOnlyCard.total',
        defaultMessage: 'Total repayment'
    },
    customise: {
        id: '_.xsell.FlexiInterestOnlyCard.customise',
        defaultMessage: 'Customise interest-only period'
    },
    customiseMessage: {
        id: '_.xsell.FlexiInterestOnlyCard.customise_message',
        defaultMessage:
            'It is currently not possible to change the interest-only period upfront. However, we will automatically re-assess you after the initial 3 months and most customers will be offered an additional 3 months interest-only period. There is no obligation to extend the interest-only period and you can always repay early.'
    },
    continue: {
        id: '_.xsell.FlexiInterestOnlyCard.continue',
        defaultMessage: 'Continue with offer'
    },
    disabledTooltip: {
        id: '_.xsell.FlexiInterestOnlyCard.disabled_tooltip',
        defaultMessage:
            'Repayment-free period possible for loan amounts between {min} - {max}'
    }
});
